import React, { useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// contentRef: ref to the DOM node you want printed/exported
// fileName: e.g. "BalanceSheet"
export default function ReportPdfBar({ contentRef, fileName }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const handlePrint = () => {
    setOpen(false);
    window.print();
  };

  const handleDownload = async () => {
    setOpen(false);
    setBusy(true);
    try {
      const node = contentRef.current;
      const canvas = await html2canvas(node, { scale: 2, useCORS: true });
      const pageWidthMm = 210;
      const pageHeightMm = 297;
      const pxPerMm = canvas.width / pageWidthMm;
      const pageHeightPx = pageHeightMm * pxPerMm;

      const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
      let renderedPx = 0;
      let first = true;

      while (renderedPx < canvas.height) {
        const sliceHeightPx = Math.min(pageHeightPx, canvas.height - renderedPx);
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = sliceHeightPx;
        const ctx = sliceCanvas.getContext("2d");
        ctx.drawImage(canvas, 0, renderedPx, canvas.width, sliceHeightPx, 0, 0, canvas.width, sliceHeightPx);

        const imgData = sliceCanvas.toDataURL("image/png");
        if (!first) pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, 0, pageWidthMm, sliceHeightPx / pxPerMm);

        renderedPx += sliceHeightPx;
        first = false;
      }
      pdf.save(`${fileName}.pdf`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block", marginLeft: 6 }}>
      <button onClick={() => setOpen((s) => !s)} disabled={busy} style={{ background: "#16a34a", color: "white", border: "none", padding: "8px 16px", borderRadius: 6, cursor: "pointer" }}>
        {busy ? "Generating..." : "Generate PDF"}
      </button>
      {open && (
        <div style={{ position: "absolute", top: 40, left: 0, background: "white", border: "1px solid #d1d5db", borderRadius: 6, boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 10, overflow: "hidden" }}>
          <button onClick={handleDownload} style={{ display: "block", width: 160, textAlign: "left", padding: "10px 14px", background: "white", border: "none", cursor: "pointer" }}>Download PDF</button>
          <button onClick={handlePrint} style={{ display: "block", width: 160, textAlign: "left", padding: "10px 14px", background: "white", border: "none", cursor: "pointer" }}>Print</button>
        </div>
      )}
    </div>
  );
}